import React, { useState, useMemo, useRef, useEffect, useCallback } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { ArrowLeftRight, PlaneTakeoff, User, X, Loader2, Minus, Plus, Calendar, PlaneLanding } from "lucide-react";
import { Dialog } from "@headlessui/react";
import { Button } from "../../components/Button";
import { DialogTravel, DialogContent, DialogTitle } from "../../components/dialog";
import flightjson from "../../data/flight_city.json";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import { useDispatch, useSelector } from 'react-redux';
import { fetchFlights, selectFlightData, selectFlightStatus, fetchgroupfare, selectGroupFareData, selectGroupFareStatus } from './flightSlice';
import { addMonths, format, isBefore, isSameDay, isWithinInterval, startOfMonth, endOfMonth, eachDayOfInterval, getDay } from "date-fns";
import { useNavigate } from "react-router-dom";
import { selectCurrentUser } from "../auth/authSlice";

// Loader Component
const SearchLoader = () => (
  <div className="flex justify-center items-center py-4">
    <Loader2 className="w-6 h-6 text-blue-600 animate-spin" />
    <span className="ml-2 text-sm text-gray-500">Loading airports...</span>
  </div>
);

export default function SearchForm({ FormData }) {

  useDocumentTitle("Welcome to B2B");
  const navigate = useNavigate()
  const user = useSelector(selectCurrentUser);
  const [isAllowedTime, setIsAllowedTime] = useState(false);

  useEffect(() => {
    const checkTime = () => {
      const now = new Date();

      // Create today 10:00 AM
      const startTime = new Date();
      startTime.setHours(10, 0, 0, 0);

      // Create today 7:00 PM
      const endTime = new Date();
      endTime.setHours(19, 0, 0, 0);

      // Check: now >= startTime && now < endTime
      const allowed =
        !isBefore(now, startTime) && isBefore(now, endTime);

      setIsAllowedTime(allowed);
    };

    checkTime();
    const interval = setInterval(checkTime, 60 * 1000);

    return () => clearInterval(interval);
  }, []);
  const Travel = (
    <>
      {FormData?.adults} Adult{FormData?.adults > 1 ? "s" : ""}
      {FormData?.children > 0 && (
        <>
          , {FormData?.children} Child{FormData?.children > 1 ? "ren" : ""}
        </>
      )}
      {FormData?.infants > 0 && (
        <>
          , {FormData?.infants} Infant{FormData?.infants > 1 ? "s" : ""}
        </>
      )}
      <br />
      {FormData?.selectedClass}
    </>
  );
  // console.log(user?.UserData?.user?.AgencyID);

  ///const Travel = `${FormData?.adults} Adult${FormData?.adults > 1 ? "s" : ""}${FormData?.children > 0 ? `, ${FormData?.children} Child${FormData?.children > 1 ? "ren" : ""}` : ""}${FormData?.infants > 0 ? `, ${FormData?.infants} Infant${FormData?.infants > 1 ? "s" : ""}` : ""}, <br/> ${FormData?.selectedClass}`;
  const [tripType, setTripType] = useState((FormData) ? FormData?.tripType : "oneway");
  const [from, setFrom] = useState((FormData) ? FormData?.from : "Delhi (DEL)");
  const [to, setTo] = useState((FormData) ? FormData?.to : "Mumbai (BOM)");
  const [departureDate, setDepartureDate] = useState((FormData) ? new Date(FormData?.departureDate) : new Date());
  const [returnDate, setReturnDate] = useState((FormData?.returnDate) ? new Date(FormData?.returnDate) : null);
  // const [travelers, setTravelers] = useState((FormData) ? Travel : '1 Adult, \nEconomy');
  const [travelers, setTravelers] = useState(
    FormData ? Travel : <>1 Adult,<br />Economy</>
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSectorModalOpen, setIsModalSector] = useState(false);
  const [modalType, setModalType] = useState("");
  const [routeType, setRouteType] = useState((FormData) ? FormData?.routeType : '1');
  const [BookOffline, setBookOffline] = useState((FormData) ? FormData?.BookOffline : false);
  const [GroupRequest, setGroupRequest] = useState((FormData) ? FormData?.GroupRequest : false);
  const [isDirectFlight, setDirectFlight] = useState((FormData && (FormData?.isDirectFlight === true || FormData?.isDirectFlight === 'true')) ? true : false);
  const [isOpen, setIsOpen] = useState(false);
  const [adults, setAdults] = useState((FormData) ? parseInt(FormData?.adults) : 1);
  const [children, setChildren] = useState((FormData) ? parseInt(FormData?.children) : 0);
  const [infants, setInfants] = useState((FormData) ? parseInt(FormData?.infants) : 0);
  const [selectedClass, setSelectedClass] = useState((FormData) ? FormData?.selectedClass : "ECONOMY");
  const [fromSearchText, setFromSearchText] = useState("");
  const [toSearchText, setToSearchText] = useState("");
  const [isFromField, setIsFromField] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [SearchDisable, setSearchDisable] = useState(false);

  const [isSearching, setIsSearching] = useState(false);
  const dispatch = useDispatch();
  const flightData = useSelector(selectFlightData);
  const flightStatus = useSelector(selectFlightStatus);
  const GroupFareData = useSelector(selectGroupFareData);
  const GroupFareStatus = useSelector(selectGroupFareStatus);
  const [specialFare, setSpecialFare] = useState((FormData) ? FormData?.FareTypes : "REGULAR");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [filteredGroupFareData, setFilteredGroupFareData] = useState(GroupFareStatus == 'succeeded' ? GroupFareData : []);
  const [selectedGroupFare, setSelectedGroupFare] = useState([]);
  const inputRef = useRef(null);
  // Debounced search handler 
  const [searchFiltersGF, setSearchFiltersGF] = useState({
    fromCity: '',
    toCity: ''
  });

  const handleFilterChange = (field, value) => {
    setSearchFiltersGF(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const handleSearchChange = (e) => {
    if (isFromField) {
      setFromSearchText(e.target.value);
    } else {
      setToSearchText(e.target.value);
    }
  };



  useEffect(() => {
    if (isSectorModalOpen) {
      const timer = setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [isSectorModalOpen]);

  const fetchgroupfaredata = async () => {
    const payload = true
    try { await dispatch(fetchgroupfare(payload)).unwrap(); }
    catch (err) { console.error("Fetch failed:", err); }
  }

  useEffect(() => {
    if (tripType === "specialfare") {
      (fetchgroupfaredata())
    }
  }, [tripType !== undefined && tripType])

  useEffect(() => {
    const searchText = isFromField ? fromSearchText : toSearchText;
    let result;
    if (!searchText) {
      const allowedAirportCode = ["DEL", "IMF", "GAU", "CCU", "BLR", "BOM", "HYD", "DXB", "GOI", "IXA", "BKK"]; // add more codes here
      result = flightjson.filter(city => allowedAirportCode.includes(city.AirportCode)).slice(0, 10);
    } else {

      result = flightjson.filter((city) => {
        const search = searchText.toLowerCase();
        return (
          (city.AirportCode ?? "").toLowerCase().includes(search) ||
          (city.city ?? "").toLowerCase().includes(search) ||
          (city.AirportName ?? "").toLowerCase().includes(search) ||
          (city.label ?? "").toLowerCase().includes(search) ||
          (city.labelWithSynonyms ?? "").toLowerCase().includes(search)
        );
      }).sort((a, b) => {
        const search = searchText.toLowerCase();

        const getRank = (item) => {
          if ((item.AirportCode ?? "").toLowerCase().startsWith(search)) return 1;
          if ((item.city ?? "").toLowerCase().startsWith(search)) return 2;
          if ((item.AirportName ?? "").toLowerCase().startsWith(search)) return 3;
          if ((item.label ?? "").toLowerCase().includes(search)) return 4;
          if ((item.labelWithSynonyms ?? "").toLowerCase().includes(search)) return 5;
          return 6;
        };
        return getRank(a) - getRank(b);
      }).slice(0, 10);
    }

    setFilteredSuggestions(result);
  }, [fromSearchText, toSearchText, isFromField, flightjson]);

  const handleIncrement = (type) => {
    if (type === "adults") setAdults(adults + 1);
    if (type === "children") setChildren(children + 1);
    if (type === "infants") setInfants(infants + 1);
    updateTravelersText(adults + (type === "adults" ? 1 : 0), children + (type === "children" ? 1 : 0), infants + (type === "infants" ? 1 : 0));
  };

  const handleDecrement = (type) => {
    if (type === "adults" && adults > 1) setAdults(adults - 1);
    if (type === "children" && children > 0) setChildren(children - 1);
    if (type === "infants" && infants > 0) setInfants(infants - 1);
    updateTravelersText(
      type === "adults" && adults > 1 ? adults - 1 : adults,
      type === "children" && children > 0 ? children - 1 : children,
      type === "infants" && infants > 0 ? infants - 1 : infants
    );
  };
  useEffect(() => {
    if ((adults + children) > 9 || infants > 8) {
      setSearchDisable(true)
    } else {
      setSearchDisable(false)
    }
  }, [adults, children, infants]);
  // const updateTravelersText = (adults, children, infants) => {
  //   const travelerText = `${adults} Adult${adults > 1 ? "s" : ""}${children > 0 ? `, ${children} Child${children > 1 ? "ren" : ""}` : ""}${infants > 0 ? `, ${infants} Infant${infants > 1 ? "s" : ""}` : ""},<br/> ${selectedClass}`;
  //   setTravelers(travelerText);
  // };

  const updateTravelersText = (adults, children, infants) => {
    const parts = [
      `${adults} Adult${adults > 1 ? "s" : ""}`,
      children > 0 && `${children} Child${children > 1 ? "ren" : ""}`,
      infants > 0 && `${infants} Infant${infants > 1 ? "s" : ""}`,
    ].filter(Boolean);

    setTravelers(
      <>
        {parts.join(", ")}
        <br />
        {selectedClass}
      </>
    );
  };

  // In your parent component, add this useEffect
  useEffect(() => {
    const hasValidGroupFare = selectedGroupFare &&
      selectedGroupFare.departureDate &&
      Array.isArray(selectedGroupFare.departureDate) &&
      selectedGroupFare.departureDate.length > 0;

    if (hasValidGroupFare) {
      setDepartureDate(null);
      // Reset return date for both routeType 2 and 3 (round trips)
      if (routeType == 2 || (routeType == 3 || tripType == 'specialfare')) {
        setReturnDate(null);
      }
    }
  }, [selectedGroupFare]); // Reset when selectedGroupFare changes

  const renderCalendar = () => {
    const months = Array.from({ length: 15 }, (_, i) => addMonths(new Date(), i));

    // Determine which date array to use based on current selection state
    const hasValidGroupFare = selectedGroupFare &&
      selectedGroupFare.departureDate &&
      Array.isArray(selectedGroupFare.departureDate) &&
      selectedGroupFare.departureDate.length > 0;

    const hasValidReturnFare = selectedGroupFare &&
      selectedGroupFare.returnDate &&
      Array.isArray(selectedGroupFare.returnDate) &&
      selectedGroupFare.returnDate.length > 0;

    // For routeType 2 (round trip) and routeType 3 (group fare round trip)
    const isRoundTrip = routeType == 2 || (routeType == 3 || tripType == 'specialfare');

    // Check if we're currently selecting return date - FIXED LOGIC
    const isSelectingReturnDate = isRoundTrip && departureDate && !returnDate;

    // Determine which dates to use
    const useReturnDates = isSelectingReturnDate && hasValidReturnFare;
    const availableDates = useReturnDates ? selectedGroupFare.returnDate : (hasValidGroupFare ? selectedGroupFare.departureDate : []);
    const hasAvailableDates = useReturnDates ? hasValidReturnFare : hasValidGroupFare;

    return (
      <div key={`calendar-${departureDate ? 'departure-set' : 'no-departure'}-${returnDate ? 'return-set' : 'no-return'}`} className="flex flex-col gap-4 overflow-y-auto h-full">
        {months.map((month, idx) => {
          const days = eachDayOfInterval({ start: startOfMonth(month), end: endOfMonth(month) });
          const firstDayIndex = getDay(startOfMonth(month));
          return (
            <div key={idx} className="border-b pb-4">
              <h3 className="text-lg font-semibold text-center mb-2">
                {format(month, "MMMM yyyy")}
                {/* {isSelectingReturnDate ? " - Select Return Date" : " - Select Departure Date"} */}
              </h3>
              <div className="grid grid-cols-7 gap-2 text-center">
                {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                  <div key={day} className="font-semibold text-gray-500">{day}</div>
                ))}
                {Array(firstDayIndex).fill(null).map((_, index) => (
                  <div key={`empty-${index}`} className="p-2"></div>
                ))}
                {days.map((day, index) => {
                  const isSelected = isSameDay(day, departureDate) || (isRoundTrip && isSameDay(day, returnDate));
                  const isInRange = isRoundTrip && departureDate && returnDate && isWithinInterval(day, { start: departureDate, end: returnDate });

                  // Format current day to match the date format
                  const currentDayFormatted = format(day, "yyyy-MM-dd");

                  // Check if current day exists in available dates
                  const isInAvailableDates = hasAvailableDates && availableDates.includes(currentDayFormatted);

                  // Determine if date should be disabled
                  let isDisabled;
                  if (hasAvailableDates) {
                    // When we have available dates, only enable dates that exist in the array
                    isDisabled = !isInAvailableDates;

                    // Additional logic for return date selection in round trips
                    if (useReturnDates && departureDate) {
                      // For return dates, also disable dates before departure date
                      isDisabled = isDisabled || isBefore(day, departureDate);
                    }
                  } else {
                    // Original logic when no selectedGroupFare
                    isDisabled = isBefore(day, new Date()) ||
                      (isRoundTrip && departureDate && !returnDate && isBefore(day, departureDate));
                  }

                  return (
                    <div
                      key={index}
                      className={`p-2 rounded-full cursor-pointer ${isSelected ? "bg-black text-white" : isInRange ? "bg-gray-300" : "hover:bg-gray-200"} ${isDisabled ? "text-gray-300 cursor-not-allowed" : ""}`}
                      onClick={() => {
                        !isDisabled && handleDateClick(day);
                      }}
                    >
                      {format(day, "d")}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const handleDateClick = useCallback((date) => {
    if (isBefore(date, new Date())) {
      console.log('Date is in past, ignoring');
      return;
    }

    const isRoundTrip = Number(routeType) === 2 || Number(routeType) === 3;

    if (Number(routeType) === 1) {
      setDepartureDate(date);
      setIsOpen(false);
    } else if (isRoundTrip) {
      if (!departureDate) {
        setDepartureDate(date);
      } else if (!returnDate) {
        setReturnDate(date);
      } else {
        setDepartureDate(date);
        setReturnDate(null);
      }
    }
  }, [routeType, departureDate, returnDate]); // Add dependencies
  const routeTypeClick = (TripType, ids) => {
    if (FormData?.reissueData?.BookingID && FormData?.reissueData?.pnr && ids === '2') {
      console.log('Blocked roundtrip due to reissue data');
      return false;
    }
    if (TripType === 'roundtrip') {
      setBookOffline(false)
    }
    if (tripType !== TripType || routeType !== ids && ids != 3) {
      setRouteType(ids);
      setTripType(TripType);
    } else {
      if (ids == 3) {
        setTripType("specialfare");
      }
    }
    if (ids != 3) {
      setSelectedGroupFare([])
      setIsOpen(true);
    }
  };

  const swapLocations = () => {
    setFrom(to);
    setTo(from);
  };

  const openModal = (type, isFrom = true) => {
    if (FormData?.reissueData?.BookingID && FormData?.reissueData?.pnr) {
      return false
    }
    setModalType(type);
    if (type === "sector") {
      setIsModalSector(true);
      setIsFromField(isFrom);
      // Reset search text based on field
      if (isFrom) {
        setFromSearchText("");
      } else {
        setToSearchText("");
      }
    } else {
      setIsModalOpen(true);
    }
  };

  const handleCitySelect = (city) => {
    const cityText = `${city.city} (${city.AirportCode})`;
    if (isFromField) {
      if (cityText === to) {
        alert("Origin and destination cannot be the same.");
        return;
      }
      setFrom(cityText);
    } else {
      if (cityText === from) {
        alert("Origin and destination cannot be the same.");
        return;
      }
      setTo(cityText);
    }
    setIsModalSector(false);
    setFromSearchText("");
    setToSearchText("");
  };

  // Build a Map once for faster lookup
  const airportMap = useMemo(() => {
    const map = new Map();
    flightjson.forEach(city => map.set(city.AirportCode, city));
    return map;
  }, []);

  useEffect(() => {
    if (tripType != "specialfare") {
      if (FormData?.IsSfS) {
        setTripType("specialfare")
        setRouteType(3)
      }
    }
  }, [])

  const handleSearchFlights = async (e) => {
    e.preventDefault();

    let grpFrom
    let grpTO
    let grpDepartureDate
    let grpReturnDate
    let grpFromairport
    let grpToairport
    let grpFromCountryCode
    let grpToCountryCode
    let interNationalSearch
    let FormDataNew
    let fromCode
    let toCode
    let GrpJourneyType

    if ((routeType == 3 || tripType == 'specialfare')) {
      grpFrom = `${selectedGroupFare.Fromcity} (${selectedGroupFare.fromairport})`
      grpTO = `${selectedGroupFare.Tocity} (${selectedGroupFare.toairport})`
      grpDepartureDate = departureDate
      grpReturnDate = (selectedGroupFare.returnDate && selectedGroupFare.returnDate.length > 0) ? format(returnDate, "yyyy-MM-dd") : ''
      grpFromairport = selectedGroupFare.fromairport
      grpToairport = selectedGroupFare.toairport
      grpFromCountryCode = selectedGroupFare.FromCountrycode
      grpToCountryCode = selectedGroupFare.ToCountrycode
      GrpJourneyType = grpReturnDate != "" ? "2" : "1"
      interNationalSearch = (grpFromCountryCode === "IN" && grpToCountryCode === "IN") ? "0" : "1";
      if (!grpFromairport || !grpToairport || !departureDate) {
        alert("Please select From, To and Departure Date.");
        return;
      }

      FormDataNew = {
        fromCode: grpFromairport,
        toCode: grpToairport,
        from: grpFrom,
        to: grpTO,
        interNational: interNationalSearch,
        JourneyType: GrpJourneyType,
        TPSystemID: 0,
        FareTypes: specialFare,
        cabinClass: selectedClass.toUpperCase(),
        departureDate: format(departureDate, "yyyy-MM-dd"),
        ADULT: adults.toString(),
        CHILD: children.toString(),
        INFANT: infants.toString(),
        returnDate: grpReturnDate,
        isDirectFlight: (isDirectFlight) ? true : false,
        isConnectingFlight: (isDirectFlight) ? false : false,
        BookOffline: BookOffline,
        GroupRequest: GroupRequest,
        IsSfS: true,
      };


    } else {

      if (!from || !to || !departureDate) {
        alert("Please select From, To and Departure Date.");
        return;
      }

      const extractCode = (text) => {
        const match = /\(([^)]+)\)/.exec(text);
        return match ? match[1] : null;
      };

      fromCode = extractCode(from);
      toCode = extractCode(to);

      if (!fromCode || !toCode) {
        alert("Invalid airport codes.");
        return;
      }

      const fromCity = airportMap.get(fromCode);
      const toCity = airportMap.get(toCode);
      if (!fromCity || !toCity) {
        alert("City not found in dataset.");
        return;
      }
      interNationalSearch = (fromCity.CountryCode === "IN" && toCity.CountryCode === "IN") ? "0" : "1";


      FormDataNew = {
        fromCode: fromCode,
        toCode: toCode,
        from: from,
        to: to,
        interNational: interNationalSearch,
        JourneyType: routeType.toString(),
        TPSystemID: 0,
        FareTypes: specialFare,
        cabinClass: selectedClass.toUpperCase(),
        departureDate: format(departureDate, "yyyy-MM-dd"),
        ADULT: adults.toString(),
        CHILD: children.toString(),
        INFANT: infants.toString(),
        returnDate: (routeType == 2) ? format(returnDate, "yyyy-MM-dd") : '',
        isDirectFlight: (isDirectFlight) ? true : false,
        isConnectingFlight: (isDirectFlight) ? false : false,
        BookOffline: BookOffline,
        GroupRequest: GroupRequest,
      };


    }

    const payload = {
      interNationalSearch: interNationalSearch,
      JourneyType: routeType.toString(),
      TPSystemID: 0,
      FareTypes: specialFare,
      APIData: {
        searchQuery: {
          cabinClass: selectedClass.toUpperCase(),
          paxInfo: {
            ADULT: adults.toString(),
            CHILD: children.toString(),
            INFANT: infants.toString()
          },
          routeInfos: [
            {
              fromCityOrAirport: { code: fromCode },
              toCityOrAirport: { code: toCode },
              travelDate: format(departureDate, "yyyy-MM-dd")
            },
            ...(routeType == 2 && returnDate
              ? [{
                fromCityOrAirport: { code: toCode },
                toCityOrAirport: { code: fromCode },
                travelDate: format(returnDate, "yyyy-MM-dd")
              }]
              : [])
          ],
          searchModifiers: {
            pft: specialFare,
            isDirectFlight: (isDirectFlight) ? true : false,
            isConnectingFlight: (isDirectFlight) ? false : false
          }
        }
      }
    };
    const bookingId = FormData?.reissueData?.BookingID;
    const pnrreissue = FormData?.reissueData?.pnr;
    if (bookingId !== undefined && bookingId !== null && bookingId !== "") {
      FormDataNew.BookingID = bookingId;
    }
    if (pnrreissue !== undefined && pnrreissue !== null && pnrreissue !== "") {
      FormDataNew.pnr = pnrreissue;
    }
    setIsSearching(true);

    const queryString = new URLSearchParams(FormDataNew).toString();
    if (bookingId !== undefined && bookingId !== null && bookingId !== "") {
      // navigate(`/flight/reissue/search?${queryString}`);
      window.location.href = `/flight/reissue/search?${queryString}`;
    } else {
      window.location.href = `/flight/search?${queryString}`;
      // navigate(`/flight/search?${queryString}`);
    }

    try {
      //setIsSearching(true);
      // const response = await dispatch(fetchFlights(payload)).unwrap();
      // // ✅ Call parent callback to close modal
      // if (typeof onSearchComplete === "function") {
      //   onSearchComplete(payload); // Or send a cleaned version if needed
      // }
      // console.log(response);
      // const queryString = new URLSearchParams(FormData).toString();
      // navigate(`/flight/search?${queryString}`);
      // navigate("/flight/roundsearch")
    } catch (err) {
      console.error("Flight search failed:", err);
    } finally {
      setIsSearching(false);
    }
  };

  const HandleDirectFlight = (event) => {
    const { value, checked } = event.target;
    setDirectFlight(checked)
  }
  const HandleBookOffline = (event) => {
    const { value, checked } = event.target;
    setBookOffline(checked)
  }
  const HandleGroupRequest = (event) => {
    const { value, checked } = event.target;
    setGroupRequest(checked)
  }

  const handleGroupfare = (data) => {
    setSelectedGroupFare(data)
    setIsOpen(true);
  }

  useEffect(() => {
    applyGroupFareFilter()

  }, [GroupFareData, searchFiltersGF]);

  const applyGroupFareFilter = () => {
    const { fromCity, toCity } = searchFiltersGF;
    let filteredData;

    if (!fromCity && !toCity) {
      filteredData = GroupFareData?.data;
    } else {
      filteredData = GroupFareData?.data.map(f => {
        if (!f.routes) return null;

        const filteredRoutes = f.routes.filter(route => {
          const fromMatch = !fromCity ||
            (route.Fromcity && route.Fromcity.toLowerCase().includes(fromCity.toLowerCase()));
          const toMatch = !toCity ||
            (route.Tocity && route.Tocity.toLowerCase().includes(toCity.toLowerCase()));
          return fromMatch && toMatch;
        });

        if (filteredRoutes.length === 0) {
          return null;
        }

        return {
          ...f,
          routes: filteredRoutes
        };
      }).filter(Boolean);
    }
    setFilteredGroupFareData({ data: filteredData });
  };
  const [activeField, setActiveField] = useState(null); // 'from', 'to', or null

  // Helper function to filter cities
  const getFilteredCities = (searchTerm) => {
    if (!searchTerm) return [];

    return flightjson.filter(city =>
      city.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
      city.AirportCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
      city.label.toLowerCase().includes(searchTerm.toLowerCase())
    ).slice(0, 5); // Limit to 5 suggestions
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (activeField && !event.target.closest('.relative')) {
        setActiveField(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [activeField]);


  return (
    <form onSubmit={handleSearchFlights}>
      <div className="bg-gray-100 flex justify-center items-center">
        <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md md:max-w-full mt-2">
          <div className="space-y-3 md:space-y-0 md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-4">
            {/* Trip Type */}
            {!FormData?.reissueData?.BookingID && !FormData?.reissueData?.pnr && (
              <div className="col-span-2 lg:col-span-3">
                <div className="flex justify-between bg-gradient-to-r from-blue-50 to-blue-100 p-2 rounded-lg shadow-sm">
                  <button type="button" className={`w-1/2 px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${tripType === "oneway"
                    ? "bg-white text-blue-600 shadow-sm transform scale-105" : "text-gray-600"}`} onClick={() => routeTypeClick("oneway", '1')}>
                    One way
                  </button>
                  <button type="button" className={`w-1/2 px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${tripType === "roundtrip" ? "bg-white text-blue-600 shadow-sm transform scale-105" : "text-gray-600"}`} onClick={() => routeTypeClick("roundtrip", '2')}>
                    Round trip
                  </button>
                  {user?.UserData?.user?.AgencyID !== 29537 && (
                    <button type="button" className={`w-1/2 px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${tripType === "specialfare" ? "bg-white text-blue-600 shadow-sm transform scale-105" : "text-gray-600"}`} onClick={() => routeTypeClick("specialfare", '3')} >
                      Special fare
                    </button>
                  )}

                </div>
              </div>
            )}

            {tripType === "specialfare" && (
              <div className="col-span-2 lg:col-span-3">

                <div className="p-4 border-2 border-blue-200 rounded-lg bg-blue-50 ">

                  {/* <h3 className="text-lg font-semibold text-gray-800 mb-4">Special Fare</h3> */}
                  <div className="md:col-span-2 lg:col-span-1 mb-4">
                    <span className="text-lg font-semibold text-gray-800 mb-4"> Select Traveller </span>
                    <div
                      className={`border rounded-lg p-3 flex items-center cursor-pointer ${!FormData?.reissueData?.BookingID && !FormData?.reissueData?.pnr ? "hover:bg-gray-50" : "bg-gray-400"} `}
                      onClick={() => openModal("travelers")}
                    >
                      <User size={20} className="text-gray-500" />
                      <span className="ml-3 text-sm font-medium text-gray-700">
                        {travelers}
                      </span>
                    </div>
                  </div>
                  <div className="space-y-6">
                    {/* Header */}
                    <div className="mx-auto mb-6 p-6 bg-white rounded-xl shadow-sm border border-gray-100">

                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        {/* From City Field */}
                        <div className="relative">
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Departure City
                          </label>
                          <div className="relative">
                            <input
                              type="text"
                              value={searchFiltersGF.fromCity}
                              onChange={(e) => handleFilterChange('fromCity', e.target.value)}
                              onFocus={() => setActiveField('from')}
                              className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                              placeholder="e.g., New York, JFK"
                            />
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              < PlaneTakeoff />
                            </div>
                          </div>

                          {/* Dropdown for From City */}
                          {activeField === 'from' && searchFiltersGF.fromCity && (
                            <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-10 max-h-60 overflow-y-auto">
                              <div className="p-3">
                                <h3 className="text-gray-500 text-sm font-medium mb-2">SUGGESTED CITIES</h3>
                                <div className="space-y-1">
                                  {getFilteredCities(searchFiltersGF.fromCity).map((city) => (
                                    <button
                                      key={city.AirportCode}
                                      onClick={() => {
                                        handleFilterChange('fromCity', city.city);
                                        setActiveField(null);
                                      }}
                                      className="flex items-center justify-between w-full p-2 rounded-lg hover:bg-blue-50 transition-colors"
                                    >
                                      <div className="flex flex-col items-start">
                                        <p className="font-medium text-sm text-black">{city.city}, {city.CountryCode}</p>
                                        <p className="text-xs text-gray-500">{city.label}</p>
                                      </div>
                                      <span className="bg-blue-100 text-blue-600 px-2 py-1 rounded-lg text-xs font-medium">
                                        {city.AirportCode}
                                      </span>
                                    </button>
                                  ))}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* To City Field */}
                        <div className="relative">
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Destination City
                          </label>
                          <div className="relative">
                            <input
                              type="text"
                              value={searchFiltersGF.toCity}
                              onChange={(e) => handleFilterChange('toCity', e.target.value)}
                              onFocus={() => setActiveField('to')}
                              className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
                              placeholder="e.g., London, LHR"
                            />
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              < PlaneLanding />
                            </div>
                          </div>

                          {/* Dropdown for To City */}
                          {activeField === 'to' && searchFiltersGF.toCity && (
                            <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-10 max-h-60 overflow-y-auto">
                              <div className="p-3">
                                <h3 className="text-gray-500 text-sm font-medium mb-2">SUGGESTED CITIES</h3>
                                <div className="space-y-1">
                                  {getFilteredCities(searchFiltersGF.toCity).map((city) => (
                                    <button
                                      key={city.AirportCode}
                                      onClick={() => {
                                        handleFilterChange('toCity', city.city);
                                        setActiveField(null);
                                      }}
                                      className="flex items-center justify-between w-full p-2 rounded-lg hover:bg-green-50 transition-colors"
                                    >
                                      <div className="flex flex-col items-start">
                                        <p className="font-medium text-sm text-black">{city.city}, {city.CountryCode}</p>
                                        <p className="text-xs text-gray-500">{city.label}</p>
                                      </div>
                                      <span className="bg-green-100 text-green-600 px-2 py-1 rounded-lg text-xs font-medium">
                                        {city.AirportCode}
                                      </span>
                                    </button>
                                  ))}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Results and Actions */}
                      <div className="mt-4 flex justify-between items-center">
                        <div className="text-sm">
                          {searchFiltersGF.fromCity || searchFiltersGF.toCity ? (
                            <span className="text-gray-600">
                              Showing <strong>{filteredGroupFareData?.data?.length || 0}</strong> results
                              {searchFiltersGF.fromCity && <span> from <strong>"{searchFiltersGF.fromCity}"</strong></span>}
                              {searchFiltersGF.toCity && <span> to <strong>"{searchFiltersGF.toCity}"</strong></span>}
                            </span>
                          ) : (
                            <span className="text-gray-500">Enter departure and/or destination to filter flights</span>
                          )}
                        </div>

                        {(searchFiltersGF.fromCity || searchFiltersGF.toCity) && (
                          <button
                            onClick={() => {
                              setSearchFiltersGF({ fromCity: '', toCity: '' });
                              setActiveField(null);
                            }}
                            className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
                          >
                            Reset Filters
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  {GroupFareStatus === "loading" ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {[1, 2].map((skeletonIndex) => (<div className="bg-white rounded-lg shadow-sm border border-green-100 p-4" key={skeletonIndex}                      >
                        <div className="flex items-center mb-3 bg-blue-500 rounded-lg">
                          <div className="w-8 h-8 bg-gray-200 rounded-full mr-3 animate-pulse"></div>
                          <div className="h-5 bg-gray-200 rounded w-32 animate-pulse"></div>
                        </div>
                        <div className="space-y-2 ml-11">
                          {[1, 2].map((routeIndex) => (<div className="flex items-center py-1 px-2" key={routeIndex}>
                            <div className="w-4 h-4 bg-gray-200 rounded mr-2 animate-pulse"></div>
                            <div className="h-4 bg-gray-200 rounded w-40 animate-pulse"></div>
                          </div>
                          ))}
                        </div>
                      </div>
                      ))}
                    </div>
                  ) : filteredGroupFareData && filteredGroupFareData.data && filteredGroupFareData.data.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {filteredGroupFareData.data.map((city, index) => {
                        const colors = [
                          'bg-blue-500',
                          'bg-green-500',
                          'bg-purple-500',
                          'bg-pink-500',
                          'bg-orange-500',
                          'bg-teal-500',
                        ];

                        const bgColor = colors[index % colors.length];

                        return (
                          <div
                            className="bg-white rounded-lg shadow-sm border border-green-100 p-4 hover:shadow-md transition-shadow"
                            key={index}
                          >
                            <div className={`flex items-center mb-3 ${bgColor} rounded-lg`}>
                              <div className="w-8 h-8 bg-white/30 rounded-full flex items-center justify-center mr-3">
                                <span className="text-white font-semibold text-lg">
                                  {city?.city?.charAt(0)}
                                </span>
                              </div>
                              <h4 className="text-md font-semibold text-white">
                                {city?.city} ({city?.fromairport})
                              </h4>
                            </div>

                            <div className="space-y-2 ml-8 grid grid-cols-1 md:grid-cols-2 gap-2">
                              {city?.routes?.length > 0 &&
                                city.routes.map((routes, routeindex) => (
                                  <div
                                    key={routeindex}
                                    onClick={() => handleGroupfare(routes)}
                                    className={`flex items-center text-sm text-gray-600 cursor-pointer transition-colors py-1 px-2 rounded 
                                      ${FormData?.fromCode + '' + FormData?.toCode === routes?.fromairport + '' + routes?.toairport
                                        ? "bg-yellow-100 hover:text-yellow-600" // highlight when Fromcity and Tocity match
                                        : "hover:bg-blue-50 hover:text-blue-600"
                                      }`}
                                  >

                                    <div>
                                      <span className="mr-2">→</span>
                                      {routes?.Fromcity} - {routes?.Tocity}
                                      {routes?.returnDate?.length > 0 && (
                                        <div className="mt-1">
                                          <span className="mr-2">→</span>
                                          {routes?.Tocity} - {routes?.Fromcity}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        );
                      })}

                      {/* {GroupFareData.data.map((city, index) => (
                        <div className="bg-white rounded-lg shadow-sm border border-green-100 p-4 hover:shadow-md transition-shadow" key={index}>
                          <div className="flex items-center mb-3 bg-blue-500 rounded-lg">
                            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                              <span className="text-blue-600 font-semibold text-sm">
                                {city?.city?.charAt(0)}
                              </span>
                            </div>
                            <h4 className="text-md font-semibold text-white">
                              {city?.city} ({city?.fromairport})
                            </h4>
                          </div>
                          <div className="space-y-2 ml-8 grid grid-cols-1 md:grid-cols-2 gap-2">
                            {city?.routes && city?.routes.length > 0 && city?.routes.map((routes, routeindex) => (
                              <div className="flex items-center text-sm text-gray-600 hover:text-blue-600 cursor-pointer transition-colors py-1 px-2 rounded hover:bg-blue-50" key={routeindex} onClick={() => handleGroupfare(routes)}>
                                <div>
                                  <span className="mr-2">→</span>
                                  {routes?.Fromcity} - {routes?.Tocity}
                                  {routes?.returnDate && routes?.returnDate.length > 0 && (
                                    <div className="mt-1">
                                      <span className="mr-2">→</span>
                                      {routes?.Tocity} - {routes?.Fromcity}
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))} */}
                    </div>
                  ) : (
                    <div className="text-center py-8 text-gray-500">
                      No special fare routes available
                    </div>
                  )}
                </div>
              </div>
            )}

            {tripType !== "specialfare" && (
              <>
                <div className="md:col-span-2 lg:col-span-1">
                  <div className={`flex items-center justify-between p-3 border rounded-lg shadow-sm ${!FormData?.reissueData?.BookingID && !FormData?.reissueData?.pnr ? "bg-white" : "bg-gray-400"}`}>
                    <div
                      className="text-left cursor-pointer flex-1 pr-2"
                      onClick={() => openModal("sector", true)}
                    >
                      <p className="text-xs text-gray-500">From - {from}</p>
                      <p className="text-base font-semibold text-gray-800">{from}</p>
                    </div>
                    <ArrowLeftRight
                      className="text-blue-600 w-6 h-6 cursor-pointer"
                      onClick={swapLocations}
                    />
                    <div
                      className="text-right cursor-pointer flex-1 pl-2"
                      onClick={() => openModal("sector", false)}
                    >
                      <p className="text-xs text-gray-500">To - {to}</p>
                      <p className="text-base font-semibold text-gray-800">{to}</p>
                    </div>
                  </div>
                </div>

                <div className="md:col-span-2 lg:col-span-1">
                  <div className="grid grid-cols-2 divide-x border rounded-lg overflow-hidden">
                    {/* Departure Date */}
                    <div
                      className="flex flex-col px-4 py-3 cursor-pointer hover:bg-gray-50"
                      onClick={() => {
                        // trigger date picker (you can open modal or calendar here)
                      }}
                    >
                      <span className="text-xs text-gray-500 uppercase tracking-wide">
                        Departure Date
                      </span>
                      {routeType === '1' && departureDate ? (
                        <div onClick={() => routeTypeClick("oneway", '1')}>
                          <div className="flex items-baseline gap-2">
                            <span className="text-base font-semibold text-gray-800">{format(departureDate, "E, dd MMM")}</span>
                          </div>
                        </div>
                      ) : routeType === '2' && departureDate ? (
                        <div onClick={() => routeTypeClick("oneway", '1')}>
                          <div className="flex items-baseline gap-2">
                            <span className="text-base font-semibold text-gray-800">{format(departureDate, "E, dd MMM")}</span>
                          </div>
                        </div>
                      ) : (
                        <div className="flex items-center gap-2 text-gray-400">
                          <Calendar size={16} /> <span>Select date</span>
                        </div>
                      )}
                    </div>

                    {/* Return Date */}
                    <div
                      className="flex flex-col px-4 py-3 cursor-pointer hover:bg-gray-50"
                      onClick={() => {
                        if (routeType === '2') {
                          // trigger date picker for return
                        }
                      }}
                    >
                      <span className="text-xs text-gray-500 uppercase tracking-wide">
                        Return Date
                      </span>
                      {routeType === '2' && returnDate ? (
                        <div onClick={() => routeTypeClick("roundtrip", '2')}>
                          <div className="flex items-baseline gap-2">
                            <span className="text-base font-semibold text-gray-800">{format(returnDate, "E, dd MMM")}</span>
                          </div>
                        </div>
                      ) : routeType === '2' ? (
                        <div className="flex items-center gap-2 text-gray-400" onClick={() => routeTypeClick("roundtrip", '2')}>
                          <Calendar size={16} /> <span>Select return date</span>
                        </div>
                      ) : (
                        <div className="text-gray-400 text-sm flex items-center gap-1" onClick={() => routeTypeClick("roundtrip", '2')}>
                          <Calendar size={16} /> Book a round trip
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="md:col-span-2 lg:col-span-1">
                  <div
                    className={`border rounded-lg p-3 flex items-center cursor-pointer ${!FormData?.reissueData?.BookingID && !FormData?.reissueData?.pnr ? "hover:bg-gray-50" : "bg-gray-400"} `}
                    onClick={() => openModal("travelers")}
                  >
                    <User size={20} className="text-gray-500" />
                    <span className="ml-3 text-sm font-medium text-gray-700">
                      {travelers}
                    </span>
                  </div>
                </div>


                {!FormData?.reissueData?.BookingID && !FormData?.reissueData?.pnr && tripType !== "specialfare" && (
                  <div className="md:col-span-2 lg:col-span-3">
                    <div className="p-2 border rounded-lg shadow-sm bg-white">
                      <p className="text-sm text-gray-500 mb-2 ml-1 font-medium">
                        Special fares (Optional)
                      </p>
                      <div className="flex flex-wrap gap-2">
                        {[
                          { key: "REGULAR", label: "Regular", sub: "Regular fares" },
                          { key: "STUDENT", label: "Student", sub: "Ext. discounts/baggage" },
                          { key: "SENIOR_CITIZEN", label: "Senior Citizen", sub: "Up to ₹600 off" }
                        ].map((fare) => (
                          <button
                            type="button"
                            key={fare.key}
                            onClick={() => setSpecialFare(fare.key)}
                            className={`flex flex-col items-start border rounded-lg px-4 py-2 w-40 transition ${specialFare === fare.key
                              ? "border-blue-600 bg-blue-50"
                              : "border-gray-300 hover:border-blue-400"
                              }`}
                          >
                            <span className="font-semibold">{fare.label}</span>
                            <span className="text-xs text-gray-500">{fare.sub}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                <div className="md:col-span-2 lg:col-span-2 gap-2 grid grid-cols-3">
                  <div>
                    <div className="flex items-center border rounded-lg p-3 hover:bg-gray-50">
                      <input
                        checked={isDirectFlight}
                        onClick={HandleDirectFlight}
                        type="checkbox"
                        className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                      />
                      <span className="ml-3 text-sm font-medium text-gray-700">
                        Direct Flight
                      </span>
                    </div>
                  </div>
                  {user?.UserData?.user?.OfflineTicket === 1 && isAllowedTime && user?.UserData?.user?.AgencyID === 97 && (
                    <div>
                      {tripType !== 'roundtrip' && (
                        <div className="flex items-center border rounded-lg p-3 hover:bg-gray-50">
                          <input
                            checked={BookOffline === true}
                            value="1"
                            type="checkbox"
                            onClick={HandleBookOffline}
                            className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                          />
                          <span className="ml-3 text-sm font-medium text-gray-700">
                            {user?.UserData?.user?.AgencyID === 97 ? 'GoerScanner' : 'We Match Your Price'} &nbsp;
                            <span className="bg-red-500 text-white text-xs px-2 py-1 rounded-full">
                              NEW
                            </span>
                          </span>
                        </div>
                      )}

                    </div>
                  )}
                  {user?.UserData?.user?.OfflineTicket === 1 && user?.UserData?.user?.AgencyID !== 97 && (
                    <div>
                      <div className="flex items-center border rounded-lg p-3 hover:bg-gray-50">
                        <input
                          checked={BookOffline === true}
                          value="1"
                          type="checkbox"
                          onClick={HandleBookOffline}
                          className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        />
                        <span className="ml-3 text-sm font-medium text-gray-700">
                          {user?.UserData?.user?.AgencyID === 97 ? 'GoerScanner' : 'We Match Your Price'} &nbsp;
                          <span className="bg-red-500 text-white text-xs px-2 py-1 rounded-full">
                            NEW
                          </span>
                        </span>
                      </div>
                    </div>
                  )}

                  <div>
                    <div className="flex items-center border rounded-lg p-3 hover:bg-gray-50">
                      <input
                        checked={GroupRequest === true}
                        value="1"
                        type="checkbox"
                        onClick={HandleGroupRequest}
                        className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                      />
                      <span className="ml-3 text-sm font-medium text-gray-700">
                        Group Request &nbsp;
                        <span className="bg-red-500 text-white text-xs px-2 py-1 rounded-full">
                          NEW
                        </span>
                      </span>
                    </div>
                  </div>

                </div>
              </>
            )}

            {tripType != "specialfare" && <div className="md:col-span-2 lg:col-span-3">
              <button
                type="submit"
                disabled={isSearching}
                className={`w-full py-3 rounded-lg shadow-md text-sm font-medium ${isSearching
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white"
                  }`}
              >
                {isSearching ? (
                  <div className="flex items-center justify-center">
                    <Loader2 className="animate-spin w-5 h-5 mr-2" /> Searching...
                  </div>
                ) : (
                  "Search flights"
                )}
              </button>
            </div>}
          </div>
        </div>


        {/* <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
          
          <div className="flex justify-between bg-gradient-to-r from-blue-50 to-blue-100 p-2 rounded-lg mb-3 shadow-sm">
            <button
              type="button"
              className={`w-1/2 px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${tripType === "oneway" ? "bg-white text-blue-600 shadow-sm transform scale-105" : "text-gray-600"}`}
              onClick={() => routeTypeClick("oneway", 1)}
            >
              One way
            </button>
            <button
              type="button"
              className={`w-1/2 px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${tripType === "roundtrip" ? "bg-white text-blue-600 shadow-sm transform scale-105" : "text-gray-600"}`}
              onClick={() => routeTypeClick("roundtrip", 2)}
            >
              Round trip
            </button>
          </div>

         
          <div className="flex items-center justify-between p-3 border rounded-lg mb-3 shadow-sm bg-white">
            <div className="text-left cursor-pointer flex-1 pr-2" onClick={() => openModal("sector", true)}>
              <p className="text-xs text-gray-500">From - {from}</p>
              <p className="text-base font-semibold text-gray-800">{from}</p>
            </div>
            <ArrowLeftRight className="text-blue-600 w-6 h-6 cursor-pointer" onClick={swapLocations} />
            <div className="text-right cursor-pointer flex-1 pl-2" onClick={() => openModal("sector", false)}>
              <p className="text-xs text-gray-500">To - {to}</p>
              <p className="text-base font-semibold text-gray-800">{to}</p>
            </div>
          </div>

          
          <div className="flex justify-between gap-4 border rounded-lg p-4 mb-3 shadow-sm">
            <div className="flex items-center gap-3 cursor-pointer text-gray-700 hover:text-blue-600" onClick={() => routeTypeClick("oneway", 1)}>
              <svg className="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <span className="text-sm font-medium">{departureDate ? format(departureDate, "E, dd MMM") : "Departure"}</span>
            </div>
            {tripType === "roundtrip" && (
              <div className="flex items-center gap-3 cursor-pointer text-gray-700 hover:text-blue-600" onClick={() => routeTypeClick("roundtrip", 2)}>
                <svg className="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span className="text-sm font-medium">{returnDate ? format(returnDate, "E, dd MMM") : "Return"}</span>
              </div>
            )}
          </div>

          
          <div className="border rounded-lg p-3 mb-3 flex items-center cursor-pointer hover:bg-gray-50" onClick={() => openModal("travelers")}>
            <User size={20} className="text-gray-500" />
            <span className="ml-3 text-sm font-medium text-gray-700">{travelers}</span>
          </div>

          
          <div className="mb-3 p-2 border rounded-lg shadow-sm bg-white">
            <p className="text-sm text-gray-500 mb-2 ml-1 font-medium">Special fares (Optional)</p>
            <div className="flex space-x-2">
              {["Senior citizen", "Student", "Armed forces"].map(fare => (
                <button key={fare} className="border bg-white hover:bg-gray-50 text-sm font-medium py-2 px-4 rounded-lg shadow-sm">
                  {fare}
                </button>
              ))}
            </div>
          </div>

          
          <div className="flex items-center border rounded-lg p-3 mb-3 hover:bg-gray-50">
            <input type="checkbox" className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500" />
            <span className="ml-3 text-sm font-medium text-gray-700">
              Unlock 10% extra savings <span className="bg-red-500 text-white text-xs px-2 py-1 rounded-full">NEW</span>
            </span>
          </div>

          
          <button
            type="submit"
            disabled={isSearching}
            className={`w-full py-3 rounded-lg shadow-md text-sm font-medium ${isSearching
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white"
              }`}
          >
            {isSearching ? (
              <div className="flex items-center justify-center">
                <Loader2 className="animate-spin w-5 h-5 mr-2" /> Searching...
              </div>
            ) : (
              "Search flights"
            )}
          </button>

        </div> */}

        {/* Travelers Modal */}
        <DialogTravel open={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <DialogContent className="rounded-t-2xl p-4 shadow-2xl z-[100]">
            <div className="flex justify-between items-center pb-4 border-b">
              <DialogTitle className="text-lg font-semibold">Select Traveller & Class</DialogTitle>
              {!SearchDisable ? (
                <Button type="button" size="icon" variant="ghost" onClick={() => setIsModalOpen(false)}>
                  <X size={20} />
                </Button>
              ) : (
                <p className="text-red-500">More than 9 Passenger's can not travel. Search Group Request</p>
              )}
            </div>
            <div className="space-y-4">
              <div>
                <h3 className="text-gray-500 text-sm font-semibold">ADD NUMBER OF TRAVELLERS</h3>
                {[
                  { label: "Adults", age: "12 yrs & above", count: adults, type: "adults" },
                  { label: "Children", age: "2 - 12 yrs", count: children, type: "children" },
                  { label: "Infants", age: "Under 2 yrs", count: infants, type: "infants" },
                ].map(({ label, age, count, type }) => (
                  <div key={type} className="flex justify-between items-center py-2">
                    <div>
                      <p className="font-semibold">{label}</p>
                      <p className="text-xs text-gray-500">{age} on the day of travel</p>
                    </div>
                    <div className="flex items-center bg-gray-100 rounded-lg px-3 py-1">
                      <Button type="button" size="icon" variant="ghost" onClick={() => handleDecrement(type)}>
                        <Minus size={16} />
                      </Button>
                      <span className="mx-3 font-medium">{count}</span>
                      <Button type="button" size="icon" variant="ghost" onClick={() => handleIncrement(type)}>
                        <Plus size={16} />
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
              <div className="grid grid-cols-2 gap-2 mt-2">
                {/* {["Economy/Premium Economy", "Premium Economy", "Business", "First Class"].map((cabin) => (
                  <Button
                    type="button"
                    key={cabin}
                    className="text-xs p-2 shadow-sm w-full"
                    variant={selectedClass === cabin ? "default" : "outline"}
                    onClick={() => { setSelectedClass(cabin); updateTravelersText(adults, children, infants); }}
                  >
                    {cabin}
                  </Button>
                ))} */}

                {[
                  { key: "ECONOMY", label: "Economic" },
                  { key: "PREMIUM_ECONOMY", label: "Premium Economic" },
                  { key: "BUSINESS", label: "Business" },
                  { key: "FIRST", label: "First Class" }
                ].map((cabin) => (
                  <Button
                    type="button"
                    key={cabin.key}
                    className="text-xs p-2 shadow-sm w-full"
                    variant={selectedClass === cabin.key ? "default" : "outline"}
                    onClick={() => { setSelectedClass(cabin.key); updateTravelersText(adults, children, infants); }}
                  >
                    {cabin.label}
                  </Button>
                ))}
              </div>
            </div>

            {!SearchDisable ? (
              <Button type="button" className="w-full bg-blue-600 mt-4 text-white" onClick={() => setIsModalOpen(false)}>
                DONE
              </Button>
            ) : (
              <p className="text-red-500 text-center">More than 9 Passenger's can not travel. Search Group Request</p>
            )}
          </DialogContent>
        </DialogTravel>

        {/* Date Selection Modal */}
        {/* <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className=" h-full w-full max-w-md bg-white p-4 flex flex-col shadow-2xl">
            <div className="flex justify-between items-center border-b pb-2">
              <h2 className="text-lg font-semibold">Select Departure Date</h2>
              <X className="cursor-pointer" onClick={() => setIsOpen(false)} />
            </div>
            <div className="flex-1 flex flex-col p-4 overflow-y-auto">
              {renderCalendar()}
            </div>
            <Button type="button" className="bg-blue-600 text-white" onClick={() => setIsOpen(false)}>Done</Button>
          </div>
        </Dialog> */}

        <Dialog
          open={isOpen}
          onClose={() => setIsOpen(false)}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
        >
          <div
            className="w-full h-full bg-white flex flex-col shadow-2xl md:h-auto md:max-h-[90vh] md:w-full md:max-w-md md:rounded-2xl"
          >
            {/* Header */}
            <div className="flex justify-between items-center border-b pb-2 p-4">
              <h2 className="text-lg font-semibold">Select Departure Date</h2>
              <X className="cursor-pointer" onClick={() => setIsOpen(false)} />
            </div>

            {/* Body */}
            <div className="flex-1 flex flex-col p-4 overflow-y-auto">
              {renderCalendar()}
            </div>

            {/* Footer */}
            <div className="p-4 border-t">
              <Button type="button" className="bg-blue-600 text-white w-full" onClick={(e) => {
                setIsOpen(false);
                if ((tripType) == 'specialfare') {
                  handleSearchFlights(e);
                }
              }}>
                Done
              </Button>
            </div>
          </div>
        </Dialog>


        {/* Airport Selection Modal */}
        <Dialog open={isSectorModalOpen} onClose={() => setIsModalSector(false)} className="fixed inset-0 flex items-end justify-center z-50">
          <div className="bg-white w-full max-w-md h-[90%] rounded-t-2xl shadow-lg p-4 flex flex-col">
            <div className="flex justify-between items-center border-b pb-2">
              <h2 className="text-lg font-semibold">{isFromField ? "Travelling From?" : "Travelling To?"}</h2>
              <button onClick={() => setIsModalSector(false)} className="p-2">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="mt-4 border rounded-lg p-3 flex items-center gap-3">
              <PlaneTakeoff className="text-blue-600" />
              <input
                ref={inputRef}
                type="text"
                value={isFromField ? fromSearchText : toSearchText}
                onChange={handleSearchChange}
                placeholder={isFromField ? "Enter Origin City/Airport" : "Enter Destination City/Airport"}
                className="w-full text-gray-500 outline-none placeholder-gray-400"
              />
            </div>
            <div className="mt-4 flex-1 flex flex-col overflow-hidden">
              <h3 className="text-gray-500 text-sm font-medium mb-2">POPULAR SEARCHES</h3>
              {isLoading ? (
                <SearchLoader />
              ) : (
                <div className="space-y-1 overflow-y-auto pr-1">
                  {filteredSuggestions.map((city) => (
                    <button
                      key={city.AirportCode}
                      onClick={() => handleCitySelect(city)}
                      className="flex items-center justify-between w-full p-2 rounded-lg hover:bg-gray-100"
                    >
                      <div className="flex flex-col items-start">
                        <p className="font-medium text-sm text-black">{city.city}, {city.CountryCode}</p>
                        <p className="text-xs text-gray-500">{city.label}</p>
                      </div>
                      <span className="bg-blue-100 text-blue-600 px-2 py-1 rounded-lg text-xs font-medium">
                        {city.AirportCode}
                      </span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </Dialog>
      </div>
    </form>
  );
}